import React, { useState } from "react";
import { Input, Form, Select, Spin } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { getGovernments } from "../../../redux/slices/governments/governmentsThunk";

const { Option } = Select;
const FormFields = ({ data }) => {
  const [limit, setLimit] = useState(10)
  const dispatch = useDispatch();
  const governments_data = useSelector((state) => state.governments.governments);
  const governments_loading = useSelector((state) => state.governments.loading);
  const hasNextPage = governments_data?.hasNextPage; // Assuming this flag indicates if more data is available

  const handleScroll = (event) => {
    const { target } = event;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      if (hasNextPage) {
        setLimit(limit + 10)
        dispatch(getGovernments({ page: 1, limit: limit }));
      }
    }
  };
  
  return (
    <>
      <Form.Item
        name="name"
        label="Région"
        key={"name"}
        rules={[
          {
            required: true,
            message: "S'il vous plaît entrer le nom de la région",
          },
        ]}
      >
        <Input defaultValue={data?.name} placeholder="Entrez le nom de la région" />
      </Form.Item>
      <Form.Item
        name="id"
        label="Gouvernorat"
        key={"gov"}
        rules={[
          {
            required: true,
            message: "S'il vous plaît Choisir une Gouvernorat",
          },
        ]}
      >
        <Select
          placeholder="Choisir une Gouvernorat"
          allowClear
          defaultValue={data?.government?.name}
          style={{ width: "100%" }}
          loading={governments_loading}
          onPopupScroll={handleScroll}
          notFoundContent={governments_loading ? <Spin size="small" /> : null} // Show a loading spinner if loading
        >
          {governments_data?.data?.map((gouvernorat) => (
            <Option key={gouvernorat.id} value={gouvernorat.id}>
              {gouvernorat.name}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};

export default FormFields;
